import React, { Component } from 'react';
import './CompanyScorePopup.css';
import PopupTitleBar from './PopupTitleBar';
import ScoreBox from '../ScoreBox';
import Config from '../../Configs/criteria.json';

export default class CompanyScorePopup extends Component {
    constructor(props) {
        super(props);
        // this.closePopupHandler = this.closePopupHandler.bind(this);
        // this.handleScoreBoxChange = this.handleScoreBoxChange.bind(this);
        // this.handleConfirm = this.handleConfirm.bind(this);

        let score = [];
        if (props.score) {
            score = [...props.score];
        } else {
            for (let i=0; i<Config.criteria.score.length; i++) {
                score.push({ disabled: true, value: [0, 10] });
            }
        }

        this.state = {
            score
        }
    }
    closePopupHandler = () => {
        this.props.closePopup();
    }
    handleScoreBoxChange = (index, disabled, value) => {
        this.score = this.state.score;
        this.score[index] = { disabled, value };
        this.setState({ score: this.score });
    }
    handleConfirm = () => {
        this.props.submit(this.state.score);
        this.closePopupHandler();
    }
    render() {
        return (
        <div className={this.props.appId==="Hyper"?"CompanyScorePopup Hyper":"CompanyScorePopup"}>
            <PopupTitleBar title="企業スコア選択" closePopup={this.closePopupHandler} />
            <div className="container">
            {
                Config.criteria.score.map((score, idx) => (
                    <ScoreBox key={score.id} label={score.name} name="score" index={idx} data={this.state.score[idx]} tooltip={score.tooltip} onScoreBoxChange={this.handleScoreBoxChange} />
                ))
            }
                <div style={{clear: "both"}} />
            </div>
            <div className="confirmbtn" onClick={this.handleConfirm}>適用</div>
        </div>
        )
    }
}